
import React from 'react';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';

interface ZoomButtonsProps {
  currentLevel: 'macro' | 'meso' | 'micro';
  onChangeLevel: (level: 'macro' | 'meso' | 'micro') => void;
}

export const ZoomButtons: React.FC<ZoomButtonsProps> = ({
  currentLevel,
  onChangeLevel
}) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex border rounded-md overflow-hidden shadow-sm bg-background">
      <Button
        variant={currentLevel === 'macro' ? 'default' : 'ghost'}
        size={isMobile ? "sm" : "sm"}
        onClick={() => onChangeLevel('macro')}
        className={`px-2 sm:px-3 py-1 rounded-none border-r ${currentLevel === 'macro' ? '' : 'text-muted-foreground'}`}
      >
        Macro
      </Button>
      <Button
        variant={currentLevel === 'meso' ? 'default' : 'ghost'}
        size={isMobile ? "sm" : "sm"}
        onClick={() => onChangeLevel('meso')}
        className={`px-2 sm:px-3 py-1 rounded-none border-r ${currentLevel === 'meso' ? '' : 'text-muted-foreground'}`}
      >
        Meso
      </Button>
      <Button
        variant={currentLevel === 'micro' ? 'default' : 'ghost'}
        size={isMobile ? "sm" : "sm"}
        onClick={() => onChangeLevel('micro')}
        className={`px-2 sm:px-3 py-1 rounded-none ${currentLevel === 'micro' ? '' : 'text-muted-foreground'}`}
      >
        Micro
      </Button>
    </div>
  );
};
